import config from '@/config'

export default {
  combine: {
    confirm_password: "Sahkan Kata Laluan",
    change_password: "Tukar Kata Laluan",
    old_password: "Lama @:ui.password",
    new_password: "@:ui.new @:ui.password",
    confirm_security_code: "Sahkan @:ui.security_code",
    first_time_login: "Log Masuk Kali Pertama",
    security_authentication: "Pengesahan Keselamatan",
    update_security: "Kemas kini Keselamatan",
    disable_security: "Lumpuhkan Keselamatan",
    add_account: "Tambah Akaun",
    add_sub_account: "Tambah Sub Akaun",
    edit_operator: "Edit Pengendali",
    edit_account: "Edit Akaun",
    edit_member: "Edit Ahli",
    approve_ticket: "Luluskan Tiket",
    reject_ticket: "Tolak Tiket",
    add_bank_account: "Tambah Akaun Bank",
    edit_bank_account: "Edit Akaun Bank",
    reset_threshold: "Tetapkan Semula Ambang",
    adjust_balance: "Laraskan Keseimbangan",
    adjust_member: "Laraskan Ahli",
    configure_bank_setting: "Konfigurasikan Tetapan Bank",
    account_setup: "Persediaan Akaun",
    bank_transfer: "Pindahan Bank",
    edit_bank_member: "Edit Ahli Bank",
    edit_ticket: "Edit Tiket",
    edit_vip: "Edit VIP",
    knock_off_promo: "Promosi Knock Off",
    edit_authority: "Kuasa Sunting",
    reset_password: "Tetapkan Semula Kata Laluan",
    update_password: "Kemas kini Kata Laluan",
    member_summary: "Ringkasan Ahli",
    reply_review: "Ulasan Balasan",
    edit_affiliate: "Ejen Edit",
    edit_bank_affiliate: "Edit Ejen Bank",
    approve_affiliate_ticket: "Luluskan Tiket Ejen",
    check_free_spin: "Semak Putaran Percuma",
    reject_affiliate_ticket: "Tolak Tiket Ejen",
    wallet_adjust: "Laraskan Dompet",
    update_comm_package: "Kemas kini Pakej Komunikasi",
    approve_affiliate: "Luluskan Ejen",
    sub_acc_detail_affiliate: "Ejen Butiran Sub Akaun",
    get_tac: "Dapatkan OTP",
    add_coupon: "Tambah Kupon",
    update_coupon: "Kemas kini Kupon",
    issue_free_spin: "Keluarkan Putaran Percuma",
    get_bank_tac: "Dapatkan OTP Bank",
    update_global_setting: "Kemas kini Tetapan Global",
    add_platform: "Tambah Platform",
    edit_platform: "Edit Platform",
    add_bank_group: "Tambah Kumpulan Bank",
    edit_bank_group: "Edit Kumpulan Bank",
    update_maintenance_schedule: "Kemas kini Jadual Penyelenggaraan",
    add_withdrawal_limit: "Tambah Had Pengeluaran",
    edit_withdrawal_limit: "Edit Had Pengeluaran",
    add_campaign: "Tambah Kempen",
    edit_campaign: "Kempen Sunting",
    add_promo_group: "Tambah Kumpulan Promosi",
    edit_promo_group: "Edit Kumpulan Promosi",
    update_team: "Pasukan Kemas kini",
    update_result: "Keputusan Kemas kini",
    insert_result: "Masukkan Hasil",
    bet_list: "Senarai Pertaruhan",
    result_list: "Senarai Keputusan",
    add_promo: "Tambah Promosi",
    raise_deposit_ticket: "Naikkan Tiket Deposit",
    bank_adjust: "Pelarasan Bank",
    promo_member_assign: "Ahli Kenaikan Pangkat Tugas",
    bonus_issue: "Isu Bonus",
    update_vip: "Kemas kini VIP",
    update_member_profile: "Kemas kini Profil Ahli",
    change_withdrawal_limit: "Tukar Had Pengeluaran",
    change_bank_group: "Tukar Kumpulan Bank",
    change_promotion_group: "Tukar Kumpulan Promosi",
    edit_promo_signup: "Edit Pendaftaran Promosi",
    update_provider_bet_limit: "Kemas kini Had Pertaruhan Pembekal",
    update_bet_limit: "Kemas kini Had Pertaruhan",
    update_member_bet_limit: "Kemas kini Had Pertaruhan Ahli",
    edit_bank_account_group: "Edit Kumpulan Akaun Bank",
    redeposit_ticket: "Deposit Semula Tiket",
    edit_promotion_group: "Edit Kumpulan Promosi",
    edit_promotion_group_norm: "Urus Promosi Dalam Kumpulan",
    get_inbox_list: "Dapatkan Senarai Peti Masuk",
    view_result_changes_detail: "Lihat butiran perubahan keputusan",
    edit_promotion_signup: "Edit Pendaftaran Promosi",
    edit_bet_limit: "Edit Had Pertaruhan",
    edit_provider_game_off: "Edit Pembekal Permainan Mati",
    edit_provider_rtp: "Edit RTP Pembekal",
    get_rebate: "Dapatkan Rebat",
    get_recent_deposit: "Dapatkan Deposit Terkini",
    add_survey: "Tambah Tinjauan",
    add_announcement_banner: "Tambah Sepanduk Pengumuman",
    edit_announcement_banner: "Edit Sepanduk Pengumuman",
    move_announcement_banner: "Sepanduk Pengumuman Pindah",
    add_promotion_banner: "Tambah Sepanduk Promosi",
    edit_promotion_banner: "Edit Sepanduk Promosi",
    unlink_banner: "Nyahpaut",
    move_promotion_banner: "Sepanduk Promosi Bergerak",
    add_slide_banner: "Tambah Sepanduk Slaid",
    edit_slide_banner: "Edit Sepanduk Slaid",
    move_slide_banner: "Bergerak Sepanduk Slaid",
    add_seo_page: "Tambah Halaman SEO",
    edit_seo_page: "Edit Halaman SEO",
    clear_outstanding: "Jelas Cemerlang",
    add_ip_whitelist: "Tambah Senarai Putih IP",
    bonus_issue_bulk: "Isu Bonus Pukal",
    edit_bank_member_ewallet: "Edit Ahli Bank (E-Dompet)",
    redeposit: "Deposit semula",
    reject_approved_ticket: "Tolak Tiket yang Diluluskan",
    audit_ticket: "Tiket Audit",
    review_ticket: "Tiket Semakan",
    edit_promotion_group_norm_seq: "Urus Urutan Promosi Dalam Kumpulan",
    edit_promo_provider_list: "Edit Senarai Penyedia Promosi",
    edit_promo_payment_option: "Edit Pilihan Pembayaran Promosi",
    edit_campaign_provider_list: "Edit Senarai Penyedia Kempen",
    update_comm: "Suruhanjaya Kemas kini",
    update_carry_over: "Kemas kini Bawa Alih",
    review_affiliate_ticket: "Tiket Ejen Semak",
    audit_affiliate_ticket: "Tiket Ejen Audit",
    get_tac_affiliate: "Dapatkan OTP (Ejen)",
    raise_deposit_ticket_gateway: "Naikkan Tiket Deposit (Gateway)",
    direct_audit_ticket: "Tiket Audit (Langsung)",
    get_rollback_detail: "Dapatkan Butiran Rollback",
    get_reject_detail: "Dapatkan Butiran Tolak",
    manual_approve_ticket: "Luluskan Tiket (Manual)",
    add_label: "Tambah Label",
    edit_label: "Edit Label",
    rollback_processing_ticket: "Tiket Pemprosesan Rollback",
    update_iframe_url: "Kemas kini URL Iframe",
    edit_exchange_rate: "Edit Kadar Pertukaran",
    add_vip: "Tambah VIP",
    add_turnover_tier: "Tambah Peringkat Perolehan",
    edit_turnover_tier: "Edit Peringkat Perolehan",
    edit_mission_reward: "Edit Ganjaran Misi",
    enable_mission_reward: "Aktifkan Ganjaran Misi",
    get_member_label_list: "Senarai Label Ahli",
    add_rescue_fund: "Tambah Dana Penyelamat",
    get_custom_member_list: "Senarai Ahli Tersuai",
    get_rescue_fund_provider: "Dapatkan Penyedia Dana Penyelamat",
    add_game_exclude: "Tambah Kecualikan Permainan",
    delete_game_exclude: "Padam Kecualikan Permainan",
    domain_custom_add_assign: "Tambah Domain",
    add_domain_batch: "Tambah Domain (Kelompok)",
    update_payment_provider_vip: "Kemas kini VIP Penyedia Pembayaran",
    update_campaign: "Kemas kini Kempen",
    purchase_domain: "Beli Domain",
    apply_domain: "Gunakan Domain",
    edit_access_control: "Edit Kawalan Akses",
    add_domain: "Tambah domain",
    operator_wallet_adjust: "Laraskan Dompet Pengendali",
    update_payment_provider_desc: "Kemas kini Penerangan Penyedia Pembayaran",
    add_package: "@:ui.add @:ui.package",
    edit_package: "@:ui.edit @:ui.package",
    add_theme_content: "@:ui.add @:ui.theme_content",
    edit_theme_content: "@:ui.edit @:ui.theme_content",
    add_theme: "@:ui.add @:ui.theme",
    edit_theme: "@:ui.edit @:ui.theme",
    add_color: "@:ui.add @:ui.color",
    edit_color: "@:ui.edit @:ui.color",
    add_content: "@:ui.add @:ui.content",
    edit_content: "@:ui.edit @:ui.content",
    delete_content: "@:ui.delete @:ui.content",
    update_setting: "@:ui.update @:ui.setting",
    add_theme_content_group: "@:ui.add @:ui.theme_content_group",
    edit_theme_content_group: "@:ui.edit @:ui.theme_content_group",
    add_bo_default_domain: "@:ui.add @:ui.bo_default_domain",
    edit_bo_default_domain: "@:ui.edit @:ui.bo_default_domain",
    update_theme: "@:ui.update @:ui.theme",
    update_menu: "@:ui.update @:ui.menu",
    update_game_menu: "@:ui.update @:ui.game_menu",
    update_special_menu: "@:ui.update @:ui.special_menu",
    update_setting_menu: "@:ui.update @:ui.setting_menu",
    update_profile_setting: "@:ui.update @:ui.profile_setting",
    update_operator_setting: "@:ui.update @:ui.operator_setting",
    add_social_account: "@:ui.add @:ui.social_account",
    edit_social_account: "@:ui.edit @:ui.social_account",
    add_site_info: "@:ui.add @:ui.site_info",
    edit_site_info: "@:ui.edit @:ui.site_info",
    add_ads: "@:ui.add @:ui.advertisement",
    edit_ads: "@:ui.edit @:ui.advertisement",
    edit_provider_hot_game: "@:ui.edit @:ui.provider @:ui.hot_game",
    edit_provider_new_game: "@:ui.edit @:ui.provider @:ui.new_game",
    edit_provider_popular_game: "@:ui.edit @:ui.provider @:ui.popular_game",
    edit_provider_featured_game: "@:ui.edit @:ui.provider @:ui.featured_game",
    setup_logo: "Logo Persediaan",
    add_livechat: "@:ui.add @:ui.livechat",
    update_livechat: "@:ui.update @:ui.livechat",
    provider_pt_operator_update: "Kemas Kini Pengendali PT Pembekal",
    provider_pt_global_update: "Kemas Kini Global PT Pembekal",
    payment_option_callback_update: "Kemas Kini URL Panggilan Balik",
    change_payment_option_seq: "Urutan Pilihan Pembayaran",
    change_payment_mode_status: "Kemas Kini Status Pilihan Pembayaran",
    change_payment_option_recommend: "Pilihan Pembayaran Mengesyorkan",
    change_payment_option_credential: "Kelayakan Pilihan Pembayaran",
    change_payment_option_limit: "Had Pilihan Pembayaran",
    change_payment_option_vip: "VIP Pilihan Pembayaran",
    add_mini_game: "@:ui.add @:ui.mini_game",
    edit_mini_game: "@:ui.edit @:ui.mini_game",
    add_mini_game_template: "@:ui.add @:ui.mini_game_template",
    edit_mini_game_template: "@:ui.edit @:ui.mini_game_template",
    edit_reward: "@:ui.edit @:ui.reward",
    gamify_update: "@:ui.update @:ui.reward",
    add_free_game_token: "@:ui.add @:ui.free_game_token",
    add_partners: "@:ui.add @:ui.partners",
    edit_partners: "@:ui.edit @:ui.partners",
    add_leaderboard: "@:ui.add @:ui.leaderboard",
    edit_leaderboard: "@:ui.edit @:ui.leaderboard",
    add_phone: "@:ui.add @:ui.phone",
    adjust_free_balance: "Adjust Free Balance",
    edit_ai_assistant: "@:ui.edit @:ui.ai_assistant",
    change_payment_option_desc: "Penerangan Pilihan Pembayaran",
    fund_transfer_provider: "Penyedia Pemindahan Dana",
    manual_deposit: "Deposit Manual",
    change_linkage_desc: "Penerangan Pautan",
    change_linkage_risk_weight: "Berat Risiko Pautan",
    add_promo_voucher: "@:ui.add @:ui.promotion_voucher",
    edit_promotion_voucher_end_date: "@:ui.edit @:ui.promotion_voucher @:ui.end_date",
    get_voucher_custom_member_list: "Dapatkan Senarai Ahli Tersuai Voucher",
    redeposit_ticket_voucher: "Deposit Semula Baucar Tiket",
    approve_ticket_voucher: "Luluskan Baucar Tiket",
    reject_ticket_voucher: "Tolak Baucar Tiket",
    raise_deposit_ticket_voucher: "Cipta Baucar Tiket Deposit",
    raise_deposit_ticket_voucher_gateway: "Cipta Baucar Tiket Deposit Gateway",
    get_voucher_list: "Dapatkan Senarai Baucar",
    get_message_list: "Dapatkan Senarai Mesej",
    edit_free_credit: "@:ui.edit @:ui.free_credit",
    knock_off_free_credit_member: "Batalkan Ahli Kredit Percuma",
    free_credit_manual_assign: "Penetapan Manual Kredit Percuma",
    review_fcp_ticket: "Semak Tiket Penyedia Kredit Percuma",
    audit_fcp_ticket: "Audit Tiket Penyedia Kredit Percuma",
    reject_fcp_ticket: "Tolak Tiket Penyedia Kredit Percuma",
    approve_fcp_ticket: "Luluskan Tiket Penyedia Kredit Percuma",
    edit_trigger: "Edit Pencetus",
    edit_trigger_status: "Edit Status Pencetus",
    adjust_voucher_balance: "Laraskan Baki Baucar",
    clear_free_credit: "Kosongkan Kredit Percuma",
    add_deposit_tier: "Tambah Tahap Deposit",
    edit_deposit_tier: "Edit Tahap Deposit",
    add_leaderboard_banner: "Tambah Banner Leaderboard",
    edit_leaderboard_banner: "Edit Banner Leaderboard",
    add_referral_banner: "Tambah Banner Referral",
    edit_referral_banner: "Edit Banner Referral",
    edit_vip_icon: "Edit Ikon VIP",
    add_reward_rain: "Tambah Reward Rain",
    edit_reward_rain: "Edit Reward Rain",
    add_reward_rain_session: "Tambah Sesi Reward Rain",
    edit_reward_rain_session: "Edit Sesi Reward Rain",
    edit_reward_rain_session_end_date: "Edit Tarikh Tamat Sesi Reward Rain",
    add_news: "Tambah Berita",
    edit_news: "Edit Berita",
  },
  short: {
    deposit_amount: "Jumlah Deposit",
    base_amount: "Jumlah asas",
    bonus_amount: "Jumlah Bonus",
    target_amount: "Jumlah Sasaran",
    knockoff_by: "K.O Oleh",
    knockoff_date: "Tarikh K.O",
    incoming_threshold: "Ambang Masuk",
    incoming_frequency: "Kekerapan Masuk",
    outgoing_threshold: "Ambang Keluar",
    outgoing_frequency: "Kekerapan Keluar",
    account_balance: "Baki Akaun",
    claim_type: "Jenis Tuntutan",
    bonus_rate: "Kadar Bonus",
    max_bonus: "Bonus Maks",
    rollover: "Rollover",
    criteria: "Kriteria",
    start_time: "Masa Mula",
    end_time: "Masa Tamat",
    monday: "Isnin",
    tuesday: "Selasa",
    wednesday: "Rabu",
    thursday: "Khamis",
    friday: "Jumaat",
    saturday: "Sabtu",
    sunday: "Ahad",
    status: "Status",
    bonus_rate_percent: "Kadar Bonus (%)",
    valid_turnover: "Perolehan yang sah",
    deposit_count: "Kiraan Deposit",
    withdrawal_amount: "Jumlah Pengeluaran",
    withdrawal_count: "Kiraan Pengeluaran",
    adjustment_amount: "Amaun Pelarasan",
    referee_count: "Kiraan Pengadil",
    signup_count: "Kiraan Pendaftaran",
    verified_count: "Kiraan Disahkan",
    active_member: "Ahli Aktif",
    ftd_count: "Kiraan FTD",
    ftd_amount: "FTD Amt",
    working_date: "Tarikh Bekerja",
    recipient_bank_id: "ID Bank Penerima",
    recipient_bank_acc_no: "Bank Penerima Acc No.",
    recipient_bank_acc_holder: "Pemegang Acc Bank Penerima",
    sender_bank: "Bank Pengirim",
    sender_bank_acc_no: "Bank Penghantar Acc No.",
    sender_bank_acc_holder: "Pemegang Acc Bank Pengirim",
    unique_login_count: "Kiraan Log Masuk Unik",
    unique_deposit_count: "Kiraan Deposit Unik",
    unique_withdrawal_count: "Kiraan Pengeluaran Unik",
    second_deposit_count: "Kiraan Deposit Kedua",
    reject_date: "Tolak Tarikh",
    processing_date: "Tarikh Pemprosesan",
    deposit_withdrawal_different: "Pengeluaran Deposit Berbeza",
    external_id: "ID luaran",
    draft_version: "Versi Draf",
    prod_version: "Prod. Versi",
    purchased_date: "Tarikh Pembelian",
    completed_amount: "Amaun Lengkap",
    min_amount: "Amaun Min.",
    max_amount: "Amaun Maks.",
    total_claimed_amount: "Jumlah Amaun Dituntut",
  },
  date_ranges: {
    0: "Hari Ini",
    1: "Semalam",
    2: "Bulan Ini",
    4: "Bulan Lepas",
  },
  langList: {
    EN: "Bahasa Inggeris",
    CN: "Cina",
    PHP: "Filipina",
    esp: "Español",
    RUS: "Rusia",
    VI: "Bahasa Vietnam",
    MS: "Bahasa Melayu",
    NE: "Bahasa Nepal",
    CT: "Bahasa Cina (Taiwan)",
    BN: "Bangla"
  },
  menulist: {
    home: "Rumah",
    hot: "Panas",
    slot_game: "Slot",
    casino: "Kasino",
    sportsbook: "Buku Sukan",
    fishing: "Memancing",
    lottery: "Loteri",
    poker: "Poker",
    hash_game: "Permainan Hash",
    sabong: "Sabong",
    promotion: "Kenaikan pangkat",
    review: "Semakan | Ulasan",
    news: "Berita",
    live_stream: "Strim Langsung",
    vip: "VIP",
    referral: "Rujukan",
    favourite: "Kegemaran",
    mission: "Misi (Permainan Mini)",
    spin: "Putaran",
    leaderboard: "Papan Pendahulu",
    account: "Akaun",
    deposit: "Deposit",
    withdrawal: "Pengeluaran",
    bet_history: "Sejarah Pertaruhan",
    pending_status: "Status Belum Selesai",
    change_password: "Tukar Kata Laluan",
    profile: "Profil",
    banking_details: "Butiran Perbankan",
    inbox: "Peti masuk",
    voucher: "Baucar",
    wallet: "Dompet",
    statement: "Pernyataan",
    download: "Muat turun",
    game: "Permainan",
    special: "Khas",
    misc: "Pelbagai",
    contact_us: "Hubungi Kami",
    e_sportsbook: "E-Buku Sukan",
    lotto: "Lotto",
    p2p: "P2P",
    other: "Lain-lain",
    vip2: "VIP2",
    referral2: "Rujukan2",
    event: "Peristiwa",
    daily_reward: "Ganjaran Harian",
    play2earn: "Main 2 Dapatkan",
    redemption: "Penebusan",
    card_board: "Papan Kad",
    lobby: "Lobi",
    in_house: "Di dalam rumah",
    transfer: "Pemindahan",
    horse_racing: "Lumba Kuda",
    register: "Daftar",
    login: "log masuk",
    transaction_history: "Sejarah Transaksi",
    bingo: "Bingo",
    member: "Ahli",
    arcade: "Arked",
    crash: "Kemalangan",
    freeplay: "Main Percuma",
    others: "Lain-lain",
  },

  ok: "OK",
  cancel: "Batal",
  login: "Log Masuk",
  logout: "Log keluar",
  add: "Tambah",
  edit: "Sunting",
  delete: "Padam",
  refresh: "Muat semula",
  action: "Tindakan",
  id: "ID",
  name: "Nama",
  all: "Semua",
  search: "Carian",
  remove: "Keluarkan",
  save: "Simpan",
  account: "Akaun",
  settings: "Tetapan",
  on: "HIDUP",
  off: "MATI",
  new: "Baru",
  clear: "Jelas",
  users: "Pengguna | Pengguna",
  username: "Nama pengguna",
  password: "kata laluan",
  created_on: "Buat Pada",
  active: "Aktif",
  page_size: "Saiz Halaman",
  status: "Status",
  result: "Keputusan",
  close: "Tutup",
  back: "Kembali",
  show: "Menunjukkan",
  login_id: "ID Log Masuk",
  date_time: "Tarikh",
  ip_address: "Alamat Ip",
  domain_name: "Nama Domain",
  browser_agent: "Ejen Penyemak Imbas",
  action_by: "Tindakan Oleh",
  details: "Butiran",
  key: "Kunci | Kunci",
  value: "Nilai | Nilai",
  from: "Daripada",
  to: "Kepada",
  type: "Jenis",
  criteria: "Kriteria",
  log: "Log",
  report: "Laporan",
  security_tag: "Tag Keselamatan",
  security_code: "Kod Keselamatan",
  submit: "Hantar",
  disable: "Lumpuhkan",
  operators: "Pengendali | Pengendali",
  members: "Ahli",
  account_id: "ID Akaun",
  confirm_password: "Sahkan Kata Laluan",
  full_name: "Nama Penuh",
  contact_phone: "Telefon Hubungan",
  contact_email: "E-mel Hubungan",
  dashboard: "Papan pemuka",
  sub_account: "Sub Akaun",
  authority_option: "Pilihan Pihak Berkuasa",
  banks: "Bank | Bank",
  login_ip: "Log Masuk Ip",
  block: "Sekat",
  profile_id: "ID Profil",
  suspend: "Gantung",
  deposit: "Deposit",
  withdrawal: "Pengeluaran",
  bulk_withdrawal: "Pengeluaran Pukal",
  rejected: "Ditolak",
  processed: "Diproses",
  pending: "Belum selesai",
  member: "Ahli",
  amount: "Jumlah",
  bank_acc_no: "Bank Acc No.",
  deposit_date: "Tarikh Deposit",
  deposit_method: "Kaedah Deposit",
  approve: "Lulus",
  reject: "Tolak",
  remark: "Kenyataan",
  ticket_detail: "Butiran Tiket",
  promo: "Promo",
  package: "Pakej",
  created_date: "Tarikh Dicipta",
  currency: "Mata wang",
  bank_acc_holder: "Pemegang Bank Acc",
  ref_no: "Ref No.",
  vip: "VIP",
  modified_date: "Tarikh Diubah Suai",
  modified_by: "Diubah suai oleh",
  bank_member: "Ahli Bank",
  bank_operator: "Pengendali Bank",
  bank_name: "Nama Bank",
  bank_acc_type: "Jenis Bank Acc",
  account_balance: "Baki Akaun",
  threshold: "Ambang",
  incoming: "Masuk",
  outgoing: "Keluar",
  frequency: "Kekerapan",
  reset_threshold: "Tetapkan Semula Ambang",
  adjust_balance: "Laraskan Baki",
  bank_from: "Bank Dari",
  bank_to: "Bank Ke",
  attachment: "Lampiran",
  sender_bank: "Bank Pengirim",
  sender_bank_acc_no: "No. Akaun Bank Pengirim",
  sender_bank_acc_holder: "Pemegang Akaun Bank Pengirim",
  audit: "Audit",
  action_status: "Status Tindakan",
  action_date: "Tarikh Tindakan",
  promotion: "Promosi",
  promo_id: "ID Promosi",
  promo_name: "Nama Promosi",
  package_id: "ID Pakej",
  claim_type: "Jenis Tuntutan",
  bonus_rate: "Kadar Bonus",
  max_bonus: "Bonus Maksimum",
  rollover: "Putaran",
  start_date: "Tarikh Mula",
  end_date: "Tarikh Tamat",
  adj_amount: "Laraskan Jumlah",
  promotion_member: "Ahli Kenaikan Pangkat",
  on_going: "Terus pergi",
  knock_off: "Knock Off",
  all_ongoing: "Semua Berterusan",
  deposit_amount: "Jumlah Deposit",
  base_amount: "Jumlah Asas",
  bonus_amount: "Jumlah Bonus",
  target_amount: "Jumlah Sasaran",
  claim_date: "Tarikh Tuntutan",
  accumulate_win: "Kumpulkan Menang",
  accumulate_turnover: "Mengumpul Perolehan",
  bonus: "Bonus",
  bonus_log: "Log Bonus",
  member_id: "ID Ahli",
  before_balance: "Sebelum Keseimbangan",
  transfer_amount: "Amaun Pemindahan",
  after_balance: "Selepas Keseimbangan",
  created_by: "Dicipta oleh",
  bonus_name: "Nama Bonus",
  bonus_desc: "Penerangan Bonus",
  bonus_type: "Jenis Bonus",
  add_promo: "Tambah Promosi",
  bonus_value: "Nilai Bonus",
  attach_promo: "Lampirkan Promosi",
  daily_statement: "Kenyataan Harian",
  working_date: "Tarikh Bekerja",
  opening_balance: "Baki Pembukaan",
  turnover: "Perolehan",
  valid_turnover: "Pusing Ganti Sah",
  winlose: "WinLose",
  withdrawal_amount: "Jumlah Pengeluaran",
  closing_balance: "Baki Penutupan",
  sub_total: "Sub Jumlah",
  grand_total: "Jumlah Besar",
  daily_winlose: "Winlose Harian",
  game_result_slots: "Keputusan Permainan (Slot)",
  game_result_livecasino: "Keputusan Permainan (Livecasino)",
  game_result_rebate: "Keputusan Permainan (Rebat)",
  game_result_sportsbook: "Keputusan Permainan (Buku Sukan)",
  game_result_cockfight: "Keputusan Permainan (Sabung Ayam)",
  game_result_rescue: "Keputusan Permainan (Menyelamat)",
  game_result_others: "Keputusan Permainan (Lainnya)",
  bet_count: "Kiraan Pertaruhan",
  result_id: "ID Keputusan",
  bet_time: "Masa Pertaruhan",
  result_time: "Masa Keputusan",
  payout: "Pembayaran",
  game_type: "Jenis Permainan",
  game_name: "Nama Permainan",
  game_provider: "Pembekal Permainan",
  reset: "Tetapkan semula",
  mode: "Mod",
  balance: "Keseimbangan",
  min_bal_knock_off_promo: "Min Bal. (Untuk membatalkan promosi secara automatik)",
  social_account: "Akaun Sosial",
  wechat: "Wechat",
  telegram: "Telegram",
  whatsapp: "Whatsapp",
  facebook: "Facebook",
  instagram: "Instagram",
  login_log: "Log Log Masuk",
  platform: "Platform",
  bank_statement: "Penyata Bank",
  transfer_date: "Tarikh Pemindahan",
  detail: "Perincian",
  date: "Tarikh",
  transfer_list: "Senarai Pemindahan",
  credit: "Kredit",
  badge: "Lencana",
  debit: "Debit",
  month: "Bulan",
  unblock: "Nyahsekat",
  unblock_member: "Nyahsekat Ahli",
  unblock_operator: "Nyahsekat Pengendali",
  referrer_id: "ID Perujuk",
  referrer_code: "Kod Perujuk",
  referral_code: "Kod Rujukan",
  bonus_and_adjustment: "Bonus & Pelarasan",
  adjustment: "Pelarasan",
  incoming_amount_threshold: "Ambang Amaun Masuk",
  outgoing_amount_threshold: "Ambang Amaun Keluar",
  knock_off_by: "Knock Off By",
  knock_off_date: "Tarikh Knock Off",
  total_turnover: "Jumlah Perolehan",
  total_winlose: "Total Winlose",
  total_deposit: "Jumlah Deposit",
  total_member: "Jumlah Ahli",
  active_player: "Pemain Aktif",
  top_winner: "Pemenang Teratas",
  top_loser: "Kalah Teratas",
  winner: "Pemenang",
  loser: "Kalah",
  deposit_count: "Bilangan Deposit",
  withdrawal_count: "Bilangan Pengeluaran",
  alert: "Berjaga-jaga",
  incoming_threshold: "Ambang Masuk",
  incoming_frequency: "Kekerapan Masuk",
  outgoing_threshold: "Ambang Keluar",
  outgoing_frequency: "Kekerapan Keluar",
  reset_password: "Tetapkan Semula Kata Laluan",
  transfer: "Pemindahan",
  company_bank: "Bank Syarikat",
  company_bank_acc_no: "Syarikat Bank Acc No.",
  company_bank_acc_holder: "Pemegang Acc Bank Syarikat",
  registered_member: "Ahli Berdaftar",
  promotion_report: "Laporan Kenaikan Pangkat",
  deposited_member: "Ahli Didepositkan",
  referred_member: "Ahli yang Dirujuk",
  validated_on: "Disahkan Pada",
  first_deposit: "Deposit Pertama",
  reward: "Ganjaran",
  inbox: "Peti Masuk",
  manual_bonus: "Bonus Manual",
  review: "Ulasan",
  reviews: "Ulasan",
  review_list: "Senarai Ulasan",
  review_detail: "Butiran Ulasan",
  reply_review: "Balas Ulasan",
  comment: "Komen",
  reply: "Balas",
  recipient_no: "No. Penerima",
  question: "Soalan",
  rating: "Penilaian",
  content: "Kandungan",
  image: "Imej",
  monthly_rating: "Penilaian Bulanan",
  affiliate: "Ejen",
  affiliate_list: "Senarai Ejen",
  affiliate_code: "Kod Ejen",
  approved_by: "Diluluskan oleh",
  approved_date: "Tarikh Diluluskan",
  bank_affiliate: "Ejen Bank",
  bank_id: "ID Bank",
  ticket_detail_affiliate: "Ejen Butiran Tiket",
  pending_application: "Permohonan Belum Selesai",
  pending_review_withdrawal: "Pengeluaran Belum Selesai & Semakan",
  unblock_affiliate: "Nyahsekat Ejen",
  wallet_adjust: "Pelarasan Dompet",
  comm_package: "Pakej Comm",
  affiliate_id: "ID Ejen",
  sub_account_detail: "Butiran Sub Akaun",
  daily_winlose_affiliate: "Daily Winlose (Ejen)",
  daily_deposit_affiliate: "Deposit Harian (Ejen)",
  export_excel: "Eksport Excel",
  get_tac: "Dapatkan OTP",
  tac_code: "Kod OTP",
  expiry_date: "Tarikh Luput",
  inactive: "Tidak aktif",
  last_deposit_date: "Tarikh Deposit Terakhir",
  coupon: "Kupon",
  allocated: "Diperuntukkan",
  claimed: "Dituntut",
  approved: "Diluluskan",
  coupon_code: "Kod Kupon",
  coupon_quota: "Kuota Kupon",
  current_allocated: "Diperuntukkan Semasa",
  new_allocated: "Diperuntukkan Baru",
  update: "Kemas kini",
  copy: "Salin",
  bonus_rate_percent: "Kadar Bonus (%)",
  coupon_desc: "Penerangan Kupon",
  both: "Kedua-duanya",
  issue_free_spin: "Keluarkan Putaran Percuma",
  game: "Permainan",
  max_win_amount: "Jumlah Kemenangan Maksimum",
  utm_list: "Senarai UTM",
  search_by_member: "Cari Mengikut Ahli",
  campaign: "Kempen",
  deposited: "Didepositkan",
  search_by_id: "Cari Mengikut ID",
  get_bank_tac: "Dapatkan OTP Bank",
  bank_statement_daily: "Penyata Bank (Harian)",
  transfer_type: "Jenis Pemindahan",
  audit_freebies_list: "Senarai Hadiah Percuma Audit",
  acknowledge: "Mengakui",
  submit_acknowledgement: "Hantar Pengakuan",
  is_ack: "Adakah Ack",
  yes: "Ya",
  no: "Tidak",
  audit_rescue_fund_list: "Senarai Dana Penyelamat Audit",
  global_setting: "Tetapan Global",
  signup_ip: "IP Pendaftaran",
  last_login_ip: "IP Log Masuk Terakhir",
  last_login_time: "Masa Log Masuk Terakhir",
  link: "Pautan",
  is_default: "adalah lalai",
  is_public: "adalah awam",
  bank_group: "Kumpulan Bank",
  set_default: "Tetapkan Lalai",
  group_id: "ID Kumpulan",
  group_name: "Nama Kumpulan",
  provider_maintenance: "Penyelenggaraan Pembekal",
  provider_code: "Kod Pembekal",
  provider_name: "Nama Pembekal",
  withdrawal_limit: "Had Pengeluaran",
  limit_id: "Had ID",
  limit_name: "Had Nama",
  daily_amount: "Jumlah Harian",
  daily_frequency: "Kekerapan Harian",
  promotion_id: "ID Promosi",
  promotion_name: "Nama Promosi",
  withhold_bonus: "Tahan Bonus",
  withhold_amount: "Penahanan Amaun",
  withhold_amt: "Tahan Amt",
  max_withdraw_amt: "Max Menarik Diri Amt",
  max_withdraw_amount: "Jumlah Pengeluaran Maksimum",
  monday: "Isnin",
  tuesday: "Selasa",
  wednesday: "Rabu",
  thursday: "Khamis",
  friday: "Jumaat",
  saturday: "Sabtu",
  sunday: "Ahad",
  start_time: "Masa Mula",
  end_time: "Masa Tamat",
  day: "Hari | Hari",
  coupon_status: "Status Kupon",
  campaign_id: "ID Kempen",
  campaign_name: "Nama Kempen",
  promotion_group: "Kumpulan Promosi",
  referee_list: "Senarai Pengadil",
  account_verified: "Akaun Disahkan",
  verified_date: "Tarikh Disahkan",
  ticket_list: "Senarai Tiket",
  vip_id: "ID Vip",
  vip_name: "Nama Vip",
  self_rebate_rate: "Kadar Rebat Sendiri(%)",
  downline_rebate_rate: "Kadar Rebat Downline(%)",
  provider: "Pembekal",
  match_id: "ID Perlawanan",
  home_team: "Pasukan Tuan Rumah",
  away_team: "Pasukan Pelawat",
  home_team_new: "Pasukan Tuan Rumah Baru",
  away_team_new: "Pasukan Tandang Baru",
  updated_by: "Dikemas kini oleh",
  updated_on: "Dikemas kini pada",
  home_score: "Skor Rumah",
  away_score: "Skor Pertandingan",
  home_score_new: "Skor Rumah Baru",
  away_score_new: "Skor Tandang Baru",
  team: "Pasukan",
  match_time: "Masa Perlawanan",
  match_round: "Pusingan Perlawanan",
  home_group: "Kumpulan Rumah",
  away_group: "Kumpulan Jauh",
  match: "Perlawanan",
  match_status: "Status Perlawanan",
  insert: "Masukkan",
  pin: "Pin",
  bet_list: "Senarai Pertaruhan",
  result_list: "Senarai Keputusan",
  bet_id: "ID Pertaruhan",
  bet_home: "Bertaruh Pulang",
  bet_away: "Bertaruh Pergi",
  bet_on: "Bertaruh",
  min_deposit: "Deposit Min",
  min_withdrawal: "Pengeluaran Min",
  raise_deposit_ticket: "Hantar Tiket Deposit",
  method: "Kaedah",
  one_time_depositor: "Pendeposit Satu Masa",
  current_month_non_depositor: "Bukan Pendeposit Bulan Semasa",
  current_month_no_login: "Bulan Semasa Tiada Log Masuk",
  ticket_date: "Tarikh Tiket",
  ftd_amount: "Jumlah FTD",
  bonus_issue: "Pengeluaran Bonus",
  promotion_summary: "Ringkasan Promosi",
  promotion_summary_detail: "Ringkasan Promosi (Butiran)",
  claim_frequency: "Kekerapan Tuntutan",
  provider_list: "Senarai Pembekal",
  platform_winlose: "Platform Winlose",
  adjustment_amount: "Jumlah Pelarasan",
  referee_count: "Bilangan Perujuk",
  category: "Kategori',",
  update_vip: "Kemaskini VIP",
  promotion_signup: "Pendaftaran Promosi",
  provider_bet_limit: "Had Pertaruhan Pembekal",
  update_member_bet_limit: "Kemaskini Had Pertaruhan Ahli",
  bet_limit: "Had Pertaruhan",
  sports_game: "Sukan/Permainan",
  league_name: "Nama Liga",
  home_team_name: "Nama Pasukan Tuan Rumah",
  away_team_name: "Nama Pasukan Lawan",
  wl_status: "Status Winlose",
  available_bank_account: "Akaun Bank Tersedia",
  group_bank_account: "Akaun Bank Kumpulan",
  edit_bank_group: "Sunting Kumpulan Bank",
  edit_bank_account_group: "Sunting Kumpulan Akaun Bank",
  redeposit: "Deposit Semula",
  upline: "Upline",
  downline: "Garis bawah",
  available_promotion: "Promosi Tersedia",
  group_promotion: "Promosi Kumpulan",
  edit_promotion_group: "Sunting Kumpulan Promosi",
  edit_promotion_group_norm: "Urus Promosi Dalam Kumpulan",
  balance_before: "Keseimbangan Sebelum",
  balance_after: "Keseimbangan Selepas",
  signup_count: "Bilangan Pendaftaran",
  verified_count: "Bilangan Disahkan",
  active_member: "Ahli Aktif",
  ftd_count: "Bilangan FTD",
  daily_summary_company: "Ringkasan Harian (Syarikat)",
  daily_summary_operator: "Ringkasan Harian (Pengendali)",
  daily_summary_member: "Ringkasan Harian (Ahli)",
  daily_ledger_operator: "Lejar Harian (Pengendali)",
  bonus_list: "Senarai Bonus",
  ltd_date: "Tarikh LTD",
  adjustment_log: "Log Pelarasan",
  get_inbox: "Dapatkan Peti Masuk",
  is_claimed: "dituntut",
  mix_parlay: "Campurkan Parlay",
  event: "Acara",
  result_changes_log: "Log Perubahan Keputusan",
  view_detail: "Lihat Butiran",
  total_referee: "Jumlah Pengadil",
  verified_signup: "Disahkan / Pendaftaran",
  ftd: "FTD | Deposit Kali Pertama",
  raw_msg: "Mesej mentah",
  unselect_all: "Nyahpilih Semua",
  select_all: "Pilih Semua",
  edit_bet_limit: "Sunting Had Pertaruhan",
  provider_game_off: "Pembekal Permainan Mati",
  provider_hot_game: "Pembekal Permainan Panas",
  game_id: "ID Permainan",
  game_list: "Senarai Permainan",
  off_list: "Luar Senarai",
  provider_rtp: "RTP Pembekal",
  rtp: "RTP",
  signup_date: "Tarikh Pendaftaran",
  free_credit: "Kredit Percuma",
  downline_rebate: "Rebat Downline",
  game_rebate: "Rebat Permainan",
  rebate: "Rebat",
  ftd_date: "Tarikh FTD",
  provider_winlose_company: "Pembekal Winlose (Syarikat)",
  provider_winlose_operator: "Pembekal Winlose (Pengendali)",
  already_hit: "Sudah Terkena",
  ongoing: "Berterusan",
  members_export: "Ahli (Eksport)",
  get_recent_deposit: "Dapatkan Deposit Terkini",
  recent_deposit: "Deposit Terkini",
  survey_list: "Senarai Tinjauan",
  modified_on: "Diubah suai pada",
  cms: "CMS",
  announcement_banner: "Sepanduk Pengumuman",
  promotion_banner: "Sepanduk Promosi",
  slide_banner: "Sepanduk Slaid",
  seo_page: "Halaman SEO",
  en_title: "Tajuk (EN)",
  cn_title: "Tajuk (CN)",
  local_title: "Tajuk (TEMPATAN)",
  en_img: "Imej (EN)",
  cn_img: "Imej (CN)",
  local_img: "Imej (TEMPATAN)",
  before_login: "Sebelum log masuk",
  after_login: "Selepas log masuk",
  en: "EN",
  move_up: "Bergerak ke atas",
  move_down: "Bergerak ke bawah",
  banner_type: "Jenis Sepanduk",
  default_order: "Pesanan lalai",
  item_order: "Pesanan Item",
  title: "Tajuk",
  banner_id: "ID Sepanduk",
  order: "Perintah",
  body: "Badan",
  en_image: "Imej (EN)",
  local_image: "Imej (TEMPATAN)",
  move: "Bergerak",
  en_img_desktop: "Desktop Imej (EN)",
  cn_img_desktop: "Desktop Imej (CN)",
  local_img_desktop: "Desktop Imej (TEMPATAN)",
  en_img_mobile: "Imej Mudah Alih (EN)",
  cn_img_mobile: "Imej Mudah Alih (CN)",
  local_img_mobile: "Imej Mudah Alih (TEMPATAN)",
  login_required: "Log Masuk Diperlukan",
  new_window_tab: "Tetingkap / Tab Baru",
  current_page: "Halaman Semasa",
  target: "Sasaran",
  event_filter: "Penapis Acara",
  alt: "Alt",
  href: "Href",
  image_desktop: "Imej Desktop",
  image_mobile: "Imej Mudah Alih",
  en_alt: "Alt (EN)",
  local_alt: "Alt (TEMPATAN)",
  en_href: "Href (EN)",
  local_href: "Href (TEMPATAN)",
  en_image_desktop: "Imej Desktop (EN)",
  active_period: "Tempoh Aktif",
  en_item: "Item (EN)",
  local_item: "Item (TEMPATAN)",
  meta_title: "Tajuk Meta",
  meta_keywords: "Kata Kunci Meta",
  meta_url: "URL Meta",
  meta_canonical: "Meta Canonical",
  meta_author: "Pengarang Meta",
  meta_publisher: "Penerbit Meta",
  meta_lang: "Meta Lang",
  meta_desc: "Meta Desc",
  meta_image: "Imej Meta",
  page: "Halaman",
  item: "Item",
  remove_desktop_image: "Alih Keluar Imej Desktop",
  remove_mobile_image: "Alih Keluar Imej Mudah Alih",
  page_name: "Nama Halaman",
  login_date: "Tarikh Log Masuk",
  ftd_amount_min: "Min. Jumlah FTD",
  ftd_amount_max: "Jumlah FTD Maks.",
  fl_provider_code: "Pembekal Pelancaran Pertama",
  fl_game_id: "ID Permainan Pelancaran Pertama",
  fl_game_name: "Nama Permainan Pelancaran Pertama",
  top_deposit: "Deposit Teratas",
  top_withdrawal: "Pengeluaran Teratas",
  top_promotion: "Promosi Teratas",
  outstanding_balance: "Baki Tertunggak",
  last_update_time: "Masa Kemas Kini Terakhir",
  trace: "Jejak",
  trace_outstanding: "Jejak Cemerlang",
  outstanding: "Cemerlang",
  clear_outstanding: "Selesaikan Tertunggak",
  meta_image_url: "Url Imej Meta",
  member_bonus: "Bonus Ahli",
  crm_list: "Senarai CRM",
  advance_search: "Carian Lanjutan",
  deposit_count_from: "Kiraan Deposit Daripada",
  deposit_count_to: "Kiraan Deposit Ke",
  deposit_amount_from: "Jumlah Deposit Daripada",
  deposit_amount_to: "Jumlah Deposit Kepada",
  min_day_no_login: "Min. Hari Tiada Log Masuk",
  min_day_no_deposit: "Min. Hari Tiada Deposit",
  last_login: "Log Masuk Terakhir",
  last_deposit: "Deposit Terakhir",
  phone: "Telefon",
  email: "E-mel",
  ip_whitelist: "Senarai Putih IP",
  ip: "IP",
  payment_option: "Pilihan Pembayaran",
  payment_mode: "Mod Pembayaran",
  payment_desc: "Desc Pembayaran",
  success: "KEJAYAAN",
  failed: "GAGAL",
  bank_member_ewallet: "Ahli Bank (E-Dompet)",
  processing: "Pemprosesan",
  recipient_bank_id: "ID Bank Penerima",
  recipient_bank_acc_no: "No. Akaun Bank Penerima",
  ticket_auto_withdrawal_log: "Log Tiket (Pengeluaran Automatik)",
  resubmit_ticket: "Hantar semula tiket",
  ticket_export: "Tiket (Eksport)",
  export_deposit: "Eksport (Deposit)",
  export_deposit_all: "Eksport Semua (Deposit)",
  export_withdrawal: "Eksport (Pengeluaran)",
  export_withdrawal_all: "Eksport Semua (Pengeluaran)",
  export_member_all: "Eksport Semua (Ahli)",
  processed_rejected: "Diproses (Ditolak)",
  channel: "Saluran",
  influencer: "Pengaruh",
  ticket_id: "ID Tiket",
  recommend: "Mengesyorkan",
  sequence: "Urutan",
  statement_info: "Maklumat Pernyataan",
  slots: "Slot",
  livecasino: "Livecasino",
  sportsbook: "Sportsbook",
  cockfight: "Sabung ayam",
  member_list: "Senarai Ahli",
  operator: "Pengendali",
  game_balance: "Keseimbangan Permainan",
  claim_limit: "Had Tuntutan",
  max_withdraw_multiple: "Max Withdraw Multiple",
  payment_gateway: "Gerbang Pembayaran",
  min_limit: "Had Min",
  max_limit: "Had Maks",
  total: "Jumlah",
  rebate_summary: "Ringkasan Rebat",
  rebate_summary_daily: "Ringkasan Rebat Setiap Hari",
  rebate_member: "Ahli Rebat",
  self: "Diri",
  system_balance: "Keseimbangan Sistem",
  rejected_onload: "Ditolak (Onload)",
  no_bonus: "Tiada Bonus",
  audit_ticket: "Tiket Audit",
  review_ticket: "Tiket Semakan",
  edit_promotion_group_norm_seq: "Urus Susunan Promosi Dalam Kumpulan",
  signup_bonus: "Bonus Pendaftaran",
  settlement_type: "Jenis Penempatan",
  carry_over: "Bawa Alih",
  comm_sports: "Suruhanjaya (Sukan)",
  comm_slots: "Komisen (Slot)",
  comm_livecasino: "Suruhanjaya (Livecasino)",
  comm_cockfight: "Suruhanjaya (Sabung Ayam)",
  comm_others: "Suruhanjaya (Lain-lain)",
  update_comm: "Kemaskini Komisen",
  update_carry_over: "Kemaskini Baki Bawa Hadapan",
  ewallet: "E-Dompet",
  withdrawal_list: "Senarai Pengeluaran",
  audit_withdrawal: "Pengeluaran Audit",
  daily_withdrawal: "Pengeluaran Harian",
  adjustment_log_affiliate: "Log Pelarasan",
  daily_statement_affiliate: "Penyata Harian (Ejen)",
  earning: "Pendapatan",
  pnl: "P&L",
  review_affiliate_ticket: "Semak Tiket Afiliasi",
  audit_affiliate_ticket: "Audit Tiket Afiliasi",
  turnover_downline: "Perolehan (Downline)",
  valid_turnover_downline: "Perolehan Sah (Downline)",
  winlose_downline: "WinLose (Downline)",
  bet_count_downline: "Kiraan Pertaruhan (Downline)",
  turnover_member: "Perolehan (Ahli)",
  valid_turnover_member: "Perolehan Sah (Ahli)",
  winlose_member: "WinLose (Ahli)",
  bet_count_member: "Kiraan Pertaruhan (Ahli)",
  dashboard_affiliate: "Papan Pemuka (Ejen)",
  total_agent: "Jumlah Ejen",
  top_turnover: "Perolehan Teratas",
  bonus_count: "Kiraan Bonus",
  deposit_amount_downline: "Jumlah Deposit (Downline)",
  deposit_count_downline: "Kiraan Deposit (Downline)",
  bonus_amount_downline: "Jumlah Bonus (Downline)",
  bonus_count_downline: "Kiraan Bonus (Downline)",
  deposit_amount_member: "Amaun Deposit (Ahli)",
  deposit_count_member: "Kiraan Deposit (Ahli)",
  bonus_amount_member: "Jumlah Bonus (Ahli)",
  bonus_count_member: "Kiraan Bonus (Ahli)",
  verified: "Disahkan",
  round_id: "ID Pusingan",
  unfinish_round: "Pusingan Belum Selesai",
  smartico_bonus_report: "Laporan Bonus Smartico",
  unclaimed_amount: "Jumlah Tidak Dituntut",
  claimed_amount: "Jumlah yang Dituntut",
  unclaimed_count: "Kiraan Tidak Dituntut",
  claimed_count: "Tuntutan Count",
  submit_time: "Tarikh Dicipta",
  deposit_time: "Tarikh Diubah Suai",
  funds_list: "Senarai Tiket",
  fund_transfer_provider: "Pembekal Pemindahan Dana",
  daifu_list_auto_withdrawal: "Senarai Tiket (Pengeluaran Automatik)",
  btn_href: "Butang Href",
  btn_text: "Teks Butang",
  recent_inbox_claim: "Tuntutan peti masuk terkini",
  raise_deposit_ticket_gateway: "Hantar Tiket Deposit (Gerbang Pembayaran)",
  gateway_acc: "Akaun Gateway",
  provider_winlose_member: "Pembekal Winlose (Ahli)",
  review_by: "Semakan oleh",
  daifu_list_auto_withdrawal_export: "Eksport Tiket (Pengeluaran Automatik)",
  retention: "Retenton",
  current_month_active_user: "Pengguna Aktif Bulan Semasa",
  current_month_active: "Bulan Semasa Aktif",
  first_month: "Bulan Pertama",
  fmwinlose: "FMWinlose",
  fmdeposit_amount: "Jumlah FMDeposit",
  cohort: "Kohort",
  promotion_withdrawal_summary: "Ringkasan Pengeluaran Promosi",
  promotion_withdrawal_summary_detail: "Ringkasan Pengeluaran Promosi (Butiran)",
  unique_player: "Pemain Unik",
  year: "Tahun | Tahun",
  audit_time_modified: "Tarikh Diubah Suai",
  audit_time_created: "Tarikh Dicipta",
  approve_time: "Tarikh Diubah Suai",
  unique_login_count: "Bilangan Log Masuk Unik",
  unique_deposit_count: "Bilangan Deposit Unik",
  unique_withdrawal_count: "Bilangan Pengeluaran Unik",
  second_deposit_count: "Bilangan Deposit Kedua",
  unique_login: "Log Masuk Unik",
  unique_withdrawal: "Pengeluaran Unik",
  second_deposit: "Deposit Kedua",
  deposit_withdrawal_different: "Perbezaan Deposit dan Pengeluaran",
  ngr: "NGR",
  audit_list: "Senarai Audit",
  rollback_count: "Kiraan Rollback",
  rejected_ticket_id: "ID Tiket Ditolak",
  rollback: "Rollback",
  recipient_bank_acc_holder: "Pemegang Akaun Bank Penerima",
  reject_date: "Tarikh Ditolak",
  processing_date: "Tarikh Pemprosesan",
  manual_approve: "Luluskan (Manual)",
  pending_review_funds: "Tiket Belum Selesai & Semakan",
  table_id: "ID Jadual",
  member_label: "Label Ahli",
  label_name: "Nama Label",
  label: "Label",
  available_label: "Label Tersedia",
  iframe: "Iframe",
  iframe_url: "URL iframe",
  exchange_rate: "Kadar Pertukaran",
  rate: "Kadar",
  rate_php: "Kadar PHP",
  ticket_withdrawal_rollback: "Pengembalian Pengeluaran Tiket",
  smartico_bonus_report_expired: "Laporan Bonus Smartico (Tamat Tempoh)",
  reward_type: "Jenis Ganjaran",
  turnover_rebate: "Rebat Perolehan",
  turnover_rebate_1: "Peringkat VIP",
  turnover_rebate_2: "Peringkat Perolehan",
  vip_cycle_day: "Hari Kitaran VIP",
  is_addon: "Adakah Addon",
  no_reward: "Tiada ganjaran",
  cash: "Tunai",
  cs: "Perkhidmatan Pelanggan",
  social_platform: "Platform Sosial",
  edit_vip: "Sunting VIP",
  edit_vip_provider: "Edit Pembekal VIP",
  turnover_tier: "Peringkat Perolehan",
  rebate_rate: "Kadar Rebat",
  edit_turnover_tier: "Sunting Tahap Perolehan",
  delete_turnover_tier: "Padamkan Peringkat Perolehan",
  vip_log: "Log VIP",
  member_full_record: "Rekod Penuh Ahli",
  before: "Sebelum",
  after: "Selepas",
  maintain: "Mengekalkan",
  actual_rebate: "Rebat Sebenar",
  rounded_rebate: "Rebat Bulat",
  rebate_mode: "Mod Rebat",
  inbox_id: "ID peti masuk",
  rebate_type: "Jenis Rebat",
  promotion_type: "Jenis Promosi",
  bonus_rate_1: "Kadar 1(%)",
  bonus_rate_2: "Kadar 2(%)",
  bonus_rate_3: "Kadar 3(%)",
  bonus_rate_4: "Kadar 4(%)",
  bonus_rate_5: "Kadar 5(%)",
  bonus_rate_6: "Kadar 6(%)",
  bonus_rate_7: "Kadar 7(%)",
  bonus_rate_8: "Kadar 8(%)",
  bonus_rate_9: "Kadar 9(%)",
  bonus_rate_10: "Kadar 10(%)",
  delete_all: "Padam Semua",
  rescue_fund: "Dana Penyelamat",
  up: "Naik",
  down: "Turun",
  rate_percent: "Kadar %",
  cycle: "Kitaran",
  actual_amount: "Jumlah Sebenar",
  rounded_amount: "Jumlah Bundar",
  rescue_id: "ID Penyelamat",
  rescue_name: "Nama Penyelamat",
  min_lose: "Min Kalah",
  max_payout: "Pembayaran Maksimum",
  payout_method: "Kaedah Pembayaran",
  target_group: "Kumpulan Sasaran",
  member_vip_id: "ID VIP Ahli",
  daily: "Setiap hari",
  weekly: "Mingguan",
  monthly: "Bulanan",
  edit_batch: "Edit Kumpulan",
  current_level: "Tahap Semasa",
  next_level: "Tahap Seterusnya",
  bet_value: "Nilai Pertaruhan",
  line_bet: "Pertaruhan Garisan",
  total_round: "Jumlah Pusingan",
  audit_by: "Audit Oleh",
  possible_next_level: "Kemungkinan Tahap Seterusnya",
  maintain_deposit: "mengekalkan deposit",
  maintain_turnover: "Kekalkan Perolehan",
  starting_deposit: "Deposit Permulaan",
  starting_turnover: "Permulaan Perolehan",
  cycle_deposit: "Deposit kitaran",
  cycle_turnover: "Perolehan Bastaran",
  vip_list: "Senarai VIP",
  up_maintain: "Menyelenggara",
  down_lowest: "Turun Paling Rendah",
  manual: "Manual",
  daily_winlose_game: "Daily Winlose (Permainan)",
  actionaff: "Tindakan (Ejen)",
  onload: "memuatkan",
  update_status: "Kemas kini Status",
  role_settings: "Tetapan Peranan",
  customer_services: "Perkhidmatan Pelanggan",
  marketing: "Pemasaran",
  finance: "Kewangan",
  payment: "Pembayaran",
  risk_management: "Pengurusan Risiko",
  pt: "PT",
  wallet_history: "Sejarah Dompet",
  ticket_amount: "Jumlah Tiket",
  ignore_risk: "Abaikan Risiko",
  permitted_amount: "Jumlah yang Dibenarkan",
  all_pending_ticket: "Semua Tiket Belum Selesai",
  rescue_fund_summary: "Ringkasan Dana Penyelamat",
  rescue_fund_summary_daily: "Ringkasan Dana Penyelamat Setiap Hari",
  rescue_fund_member: "Ahli Tabung Penyelamat",
  master: "Tuan",
  account_type: "Jenis Akaun",
  freeze: "Beku",
  domain_member_setup: "Persediaan Domain laman ahli",
  domain: "Domain",
  domain_list: "Senarai Domain",
  domain_application: "Permohonan Domain",
  domain_status: "Status Domain",
  domain_group: "Kumpulan Domain",
  operator_id: "ID Pengendali",
  domain_type: "Jenis Domain",
  module: "Modul",
  template: "Templat",
  custom: "Adat",
  default: "Lalai",
  payment_provider: "Pembekal Pembayaran",
  payment: "Pembayaran",
  deactivate: "Tidak aktif",
  name_server: "Pelayan Nama",
  server_account: "Akaun Pelayan",
  service_provider: "Pembekal Perkhidmatan",
  process: "Proses",
  provider_operator: "Pengendali Pembekal",
  bet_limit_member: "@:ui.bet_limit (@:ui.member)",
  global: "Tetapan Global",
  second_id: "ID Kedua",
  unverified: "Tidak disahkan",
  pt_affiliate: "Caj Platform Ejen (%)",
  recipient_bank: "Bank Penerima",
  deposit_type: "Jenis Deposit",
  security_fund: "Dana Keselamatan",
  adjust_balance_op: "Laraskan Dompet Pengendali",
  adjust_security_deposit_op: "Laraskan Dana Keselamatan Pengendali",
  marquee: "Marquee",
  marquee_content: "Kandungan marquee",
  edit_marquee: "Edit Marquee",
  domain_available: "Domain Tersedia",
  daily_withdrawal_frequency: "Kekerapan Pengeluaran Harian",
  maintenance: "Penyelenggaraan",
  max_withdrawal: "Pengeluaran Maksimum",
  min_balance: "Baki Minimum",
  affiliate_report: "Laporan ejen",
  cash_balance: "Baki Tunai",
  copy_success: "Berjaya menyalin!",
  copy_failed: "Salinan gagal!",
  your_website: "Laman Web Anda",
  correction_promo: "Tambahkan Promosi",
  others: "Lain-lain",
  audit_log: "Log Audit",
  view: "Lihat",
  price: "Harga",
  package_level: "Tahap Pakej",
  bo_right: "BO Betul",
  english: "Bahasa Inggeris",
  simplified_chinese: "Cina (CN)",
  traditional_chinese: "Cina (TW)",
  philippine: "Filipina",
  thai: "Thai",
  vietnamese: "Vietnam",
  indonesian: "Indonesia",
  myanmar: "Myanmar",
  japanese: "Jepun",
  korean: "Korea",
  package_type: "Jenis Pakej",
  full_back_office_access_right: "Hak Akses Pejabat Belakang Penuh",
  read_only_back_office: "Pejabat Belakang Readonly",
  language: "Bahasa",
  lang_code: "Kod Bahasa",
  description: "Penerangan",
  provider_type: "Jenis Pembekal",
  logo: "Logo",
  theme_provider: "Pembekal Tema",
  theme_content: "Kandungan Tema",
  content_id: "ID Kandungan",
  content_desc: "Desc Kandungan",
  theme_content_position: "Kedudukan Kandungan Tema",
  theme: "Tema",
  theme_code: "Kod Tema",
  theme_name: "Nama Tema",
  color: "Warna",
  position: "Kedudukan",
  site_name: "Nama Tapak",
  theme_color: "Warna Tema",
  theme_purchased: "Tema Dibeli",
  total_purchased: "Jumlah Pembelian",
  purchased_date: "Tarikh Pembelian",
  purchase: "Pembelian",
  total_site: "Jumlah Tapak",
  content_setup: "Persediaan Kandungan",
  site_list: "Senarai Tapak",
  site_id: "ID Tapak",
  draft_version: "Versi Draf",
  prod_version: "Versi Produksi",
  production_version: "Versi Pengeluaran",
  info: "Maklumat",
  setting: "Tetapan",
  site_info: "Maklumat Tapak",
  menu: "Menu",
  game_menu: "Menu Permainan",
  special_menu: "Menu Khas",
  setting_menu: "Menu Tetapan",
  error: "Ralat",
  sync_all: "Segerakkan Semua",
  theme_content_group: "Kumpulan Kandungan Tema",
  content_group: "Kumpulan Kandungan",
  content_group_desc: "Desc Kumpulan Kandungan",
  parent_content_id: "ID Kandungan Ibu Bapa",
  bo_default_domain: "Domain Lalai BO",
  domain_id: "ID Domain",
  deactive: "Tidak aktif",
  site_sync: "Penyegerakan Tapak",
  upload: "Muat naik",
  comingSoon: "Akan Datang Tidak Lama Lagi",
  profile_setting: "Tetapan Profil",
  bank: "Bank",
  company: "Syarikat",
  own: "SENDIRI",
  operator_setting: "Tetapan Pengendali",
  external_id: "ID Luaran",
  ticket: "Tiket",
  bank_owner: "Pemilik Bank",
  exchanged_currency: "Mata Wang yang Ditukar",
  company_bank_owner: "Pemilik Bank Syarikat",
  ticket_list_member: "Senarai Tiket (Ahli)",
  game_name_exclude: "Nama Permainan Kecualikan",
  tab: "Tab",
  about_us: "Tentang Kami",
  privacy_policy: "Dasar Privasi",
  responsible_gaming: "Permainan Bertanggungjawab",
  banking: "Perbankan",
  faqs: "Soalan Lazim",
  advertisement: "Pengiklanan",
  px_pixel_id: "ID Piksel PX",
  px_token: "Token PX",
  af_dev_key: "Kunci Af Dev",
  af_apps_id: "Af Apps ID",
  pp_tid: "PP TID",
  pp_pid: "PP PID",
  pp_aid: "BANTUAN PP",
  gtm_id: "ID GTM",
  service_provider_url: "URL Pembekal Perkhidmatan",
  script_inject: "Suntikan Skrip",
  head_script: "Skrip Kepala",
  body_script: "Skrip Badan",
  ads_id: "ID Iklan",
  member_detail: "Butiran Ahli",
  memberreport: "Laporan Ahli",
  member_log: "Log Ahli",
  general: "Jeneral",
  top_theme: "Tema Teratas",
  hot_game: "Permainan Panas",
  hot_list: "Senarai Panas",
  new_game: "Permainan Baru",
  popular_game: "Permainan Popular",
  featured_game: "Permainan Pilihan",
  new_list: "Senarai Baru",
  popular_list: "Senarai Popular",
  featured_list: "Senarai Pilihan",
  provider_new_game: "Pembekal Permainan Baharu",
  provider_popular_game: "Permainan Popular Penyedia",
  provider_featured_game: "Permainan Pilihan Penyedia",
  website: "laman web",
  site_customization: "Penyesuaian Tapak",
  export_all: "Eksport Semua",
  export_one: "Eksport (Halaman Semasa)",
  daily_ledger: "Lejar Harian",
  daily_ledger_member: "Lejar Harian (Ahli)",
  promotion_signup_unused: "Promosi Pendaftaran Tidak Digunakan",
  promotion_signup_ongoing: "Promosi Pendaftaran Berterusan",
  promotion_signup_winlose: "Promosi Pendaftaran Winlose",
  promotion_signup_winlose_operator: "Promosi Pendaftaran Winlose (Pengendali)",
  promotion_signup_winlose_member: "Promosi Pendaftaran Winlose (Ahli)",
  total_player_balance: "Jumlah Baki Pemain",
  search_all: "Cari Semua",
  mbsetting: "Tetapan",
  todays_highlights: "Sorotan Hari Ini",
  deposit_player: "Pemain Deposit",
  withdrawal_player: "Pemain Pengeluaran",
  kill_rate: "Kadar Bunuh",
  login_player: "Pemain Log Masuk",
  operation_management: "Operasi",
  game_management: "Permainan",
  member_management: "Ahli",
  affiliate_management: "Ejen",
  promotion_management: "Kenaikan pangkat",
  mbcampaign: "Kempen",
  promo_allday: "Sepanjang Hari",
  promo_daily: "Setiap hari",
  promo_daily_first_deposit: "Deposit Pertama Harian",
  promo_deposit_monthly: "Kiraan Deposit Bulanan",
  promo_deposit_signup: "Pendaftaran Kiraan Deposit",
  promo_deposit_weekly: "Kiraan Deposit Mingguan",
  promo_newbie: "Pemula",
  promo_once: "Sekali",
  dd_review: "Ulasan",
  game_provider_management: "Pembekal",
  exchanged_amount: "Jumlah yang Ditukar",
  operator_summary: "Ringkasan Pengendali",
  business_id: "ID Perniagaan",
  game_name_exclude_log: "Nama Permainan Kecualikan Log",
  cn: "CN",
  local: "TEMPATAN",
  taken: "Diambil",
  receiver_bank: "Bank Penerima",
  receiver_bank_acc_no: "Receiver Bank Acc No.",
  receiver_bank_acc_holder: "Pemegang Acc Bank Penerima",
  add_balance: "Tambah Baki",
  deduct_balance: "Tolak Baki",
  sync_site_content: "Segerakkan Kandungan Tapak",
  payment_setting: "Tetapan Pembayaran",
  payment_own: "SENDIRI",
  payment_global: "GLOBAL",
  livechat: "Sembang Langsung",
  chat_id: "Kunci Lesen LiveChat",
  chat_provider: "Pembekal LiveChat",
  auto_cycle: "KITARAN",
  auto_all: "SEMUA",
  completed_amount: "Jumlah Selesai",
  website_launched: "Laman Web Dilancarkan",
  total_operators: "Jumlah Pengendali",
  today_active: "Hari Ini Aktif",
  new_player_verified_signup: "Pemain baru Disahkan/Pendaftaran",
  total_players: "Jumlah Pemain",
  depo_withdrawal_diff: "DEPO-DENGAN Perbezaan",
  claim_count: "Kiraan Tuntutan",
  ggr: "GGR",
  member_balance: "Baki Ahli",
  players: "Pemain",
  provider_pt: "PT Pembekal",
  base: "Pangkalan",
  topup_id: "ID tambah nilai",
  credential: "Kelayakan",
  credential_1: "Kelayakan 1",
  credential_2: "Kelayakan 2",
  credential_3: "Kelayakan 3",
  credential_4: "Kelayakan 4",
  credential_5: "Kelayakan 5",
  credential_6: "Kelayakan 6",
  credential_7: "Kelayakan 7",
  credential_8: "Kelayakan 8",
  credential_9: "Kelayakan 9",
  credential_10: "Kelayakan 10",
  limit: "Had",
  create: "Buat",
  hint: "Petunjuk",
  quickSetup: "Persediaan Pantas",
  next: "Seterusnya",
  setUpTheme: "SetUp Theme",
  checkOut: "Daftar Keluar",
  standardPackage: "Pakej Standard",
  siteName: "Nama Tapak",
  information: "Maklumat",
  useThisTemplate: "Gunakan templat ini",
  summary: "Ringkasan",
  createOperatorAccount: "Buat Akaun Pengendali",
  operatorId: "ID Pengendali",
  operatorPwd: "Pedang Laluan Pengendali",
  new_website: "Laman Web Baru",
  operator_information: "Maklumat Pengendali",
  bo_link: "Pautan BO",
  daily_summary_sms: "SMS Ringkasan Harian",
  daily_summary_sms_operator: "Pengendali SMS Ringkasan Harian",
  daily_summary_sms_operator_detail: "Butiran Pengendali SMS Ringkasan Harian",
  sms_count: "Kiraan SMS",
  provider_winlose_operator_pt: "Pembekal Winlose (Operator PT)",
  pt_on: "PT Hidup",
  share_operator: "Pengendali Kongsi",
  share_company: "Syarikat Saham",
  token_log: "Log Token",
  template_code: "Kod Templat",
  template_name: "Nama Templat",
  mini_game: "Permainan Mini",
  max_game_reward: "Max. Ganjaran Permainan",
  max_chance_per_day: "Max. Peluang setiap Hari",
  is_recurring_chance: "Berulang",
  token_request: "Token",
  enabled: "didayakan",
  disabled: "Kurang upaya",
  unlimited: "Tidak terhad",
  max_chance_unlimited: "Max. Peluang setiap Hari Tidak Terhad",
  mini_game_template: "Templat Permainan Mini",
  reward_code: "Kod Ganjaran",
  reward_name: "Nama Ganjaran",
  reward_description: "Penerangan Ganjaran",
  reward_probability: "Kebarangkalian Ganjaran",
  total_game: "Jumlah Permainan",
  total_played_mini_game: "Jumlah Permainan Mini yang Dimainkan",
  total_played_mini_game_detail: "Jumlah Perincian Permainan Mini yang Dimainkan",
  total_played_mini_game_detail_operator: "Jumlah Perincian Permainan Mini yang Dimainkan (Pengendali)",
  daily_pnl_operator: "P&L (Pengendali) Harian",
  token: "Token",
  token_1: "Token 1",
  token_2: "Token 2",
  token_3: "Token 3",
  token_4: "Token 4",
  token_5: "Token 5",
  token_6: "Token 6",
  token_7: "Token 7",
  cash_1: "Tunai 1",
  cash_2: "Tunai 2",
  cash_3: "Tunai 3",
  cash_4: "Tunai 4",
  cash_5: "Tunai 5",
  cash_6: "Tunai 6",
  cash_7: "Tunai 7",
  daily_login: "Daftar Masuk Harian (Log Masuk Harian)",
  daily_login_update: "Kemas kini Daftar Masuk Harian (Log Masuk Harian)",
  game_result_reward: "Keputusan Permainan (Ganjaran)",
  current_streak: "Coretan Semasa",
  login_streak: "Coretan Log Masuk",
  total_token: "Jumlah Token",
  total_mini_game_token_used: "Jumlah Token Permainan Mini Digunakan",
  total_mini_game_token_used_detail: "Jumlah Token Permainan Mini yang Digunakan Perincian",
  total_mini_game_token_used_detail_operator: "Jumlah Token Permainan Mini yang Digunakan Perincian (Pengendali)",
  total_reward: "Jumlah ganjaran",
  total_mini_game_reward: "Jumlah Ganjaran Permainan Mini",
  total_mini_game_reward_detail: "Jumlah Perincian Ganjaran Permainan Mini",
  total_mini_game_reward_detail_operator: "Jumlah Butiran Ganjaran Permainan Mini (Pengendali)",
  token_balance: "Baki Token",
  free_game_token: "Token Permainan Percuma",
  bo_url: "Url Backoffice",
  copied: "Disalin",
  callback: "Panggilan balik",
  api: "API",
  prefix: "awalan",
  delimiter: "Pembatas",
  url_callback_deposit: "URL Panggilan Balik Deposit",
  url_callback_withdrawal: "URL Panggilan Balik Pengeluaran",
  url_callback_affiliate: "URL Panggilan Balik Ejen",
  url_api_deposit: "URL Panggilan Balik Deposit (API)",
  url_api_withdrawal: "URL Panggilan Balik Pengeluaran (API)",
  url_api_balance: "URL Panggilan Balik Baki (API)",
  prefix_deposit: "Awalan Deposit",
  prefix_withdrawal: "Awalan Pengeluaran",
  prefix_affiliate: "Awalan ejen",
  prefix_delimiter: "Awalan Pembatas",
  merchant: "Saudagar",
  app_id: "ID Apl",
  secret_key: "Kunci Rahsia",
  deposit_secret_key: "Kunci Rahsia Deposit",
  withdrawal_secret_key: "Kunci Rahsia Pengeluaran",
  partners: "Rakan Kongsi",
  partner_name: "Nama Rakan Kongsi",
  win: "Menang",
  manifest: "Manifest",
  crop: "Tanaman",
  cropImage: "Pangkas Imej",
  api_url: "URL API",
  start_date_time: "Tarikh Mula Masa",
  end_date_time: "Masa Tarikh Tamat",
  authentication_key: "Kunci Pengesahan",
  one_week: "1 Minggu",
  two_week: "2 Minggu",
  one_month: "1 Bulan",
  two_month: "2 Bulan",
  six_month: "6 Bulan",
  edit_promotion_end_date: "Edit Tarikh Tamat Promosi",
  android_app_link: "Pautan Apl Android",
  add_android_app_link: "Tambah Pautan Apl Android",
  operator_details: "Butiran Pengendali",
  bsb: "BSB",
  payid: "ID Bayar",
  cuit: "CUIT",
  merchant_key: "Kunci Saudagar",
  aes_key: "Kunci AES",
  paycode: "Kod Bayar",
  api_key: "Kunci API",
  referral: "Ganjaran Rujukan",
  minimum_deposit: "Deposit Minimum",
  minimum_withdrawal: "Pengeluaran Minimum",
  maximum_withdrawal: "Pengeluaran Maksimum",
  cpi: "CPI",
  cpi_enrol: "Daftar CPI",
  interested: "Berminat",
  non_pickup: "Tidak Diambil",
  invalid: "Tidak Sah",
  cpi_member_list: "Senarai Ahli CPI",
  leaderboard: "Papan Pendahulu",
  capacity: "Kapasiti",
  reward_count: "Jumlah Ganjaran",
  is_settled: "Telah Diselesaikan",
  settlement_date: "Tarikh Penyelesaian",
  prize: "Hadiah",
  count: "Jumlah",
  multiplier: "Pengganda",
  ranking: "Kedudukan",
  leaderboard_ranking: "Kedudukan Papan Pendahulu",
  joined_date: "Tarikh Sertai",
  ready: "Sedia",
  busy: "Sibuk",
  phone_list: "Senarai Telefon",
  single: "Tunggal",
  batch: "Kumpulan",
  cpi_operator_phone_list: "Senarai Telefon Operator CPI",
  selected: "Dipilih",
  call: "Panggil",
  private_key: "Kunci Peribadi",
  public_key: "Kunci Awam",
  multi_call: "Panggilan Berbilang",
  add_custom: "Tambah Tersuai",
  custom_list: "Senarai Tersuai",
  assignee: "Orang Ditugaskan",
  urgency: "Tahap Kecemasan",
  urgency_1: "Rendah",
  urgency_2: "Sederhana",
  urgency_3: "Tinggi",
  edit_custom: "Edit Tersuai",
  cpi_custom_list: "Senarai Tersuai CPI",
  free_coin_signup: "Mata Percuma (Daftar)",
  free_coin_daily: "Mata Percuma (Harian)",
  free_coin_min_withdrawal: "Pengeluaran Minimum (Mata Percuma)",
  free_coin_per_unit: "Kadar Pertukaran Mata Percuma (Mata = {currency} 1)",
  adjust_free_balance: "Laraskan Baki Percuma",
  adjust_free_balance_log: "Log Baki Percuma",
  signup: "Daftar",
  adjust: "Laraskan",
  ai_assistant: "Pembantu AI",
  en_name: "Nama (EN)",
  cn_name: "Nama (CN)",
  local_name: "Nama (LOKAL)",
  img_small: "Imej (Kecil)",
  img_large: "Imej (Besar)",
  small_image: "Imej Kecil",
  large_image: "Imej Besar",
  forgot_password: "Lupa Kata Laluan",
  update_password: "Kemaskini Kata Laluan",
  contact: "Hubungi",
  keyss: "Kunci",
  iv: "IV",
  callback_public_key: "Kunci Awam Callback",
  free_game: "Permainan Percuma",
  version_no: "Nombor Versi",
  client_id: "ID Klien",
  symmetric_key: "Kunci Simetri",
  deposit_token: "Token Deposit",
  withdrawal_token: "Token Pengeluaran",
  tac_bank: "OTP (Bank)",
  tac_login: "OTP (Log Masuk)",
  tac_signup: "OTP (Daftar)",
  tac_signup_aff: "OTP (Daftar Ahli Gabungan)",
  merchant_name: "Nama Peniaga",
  tele_status: "Status Tele",
  follow_up: "Tindakan Susulan",
  call_type: "Jenis panggilan",
  on_call_list: "Dalam senarai panggilan",
  inbox_valid_day: "Hari sah peti masuk",
  manual_deposit: "Deposit Manual",
  withdrawal_result: "Keputusan Pengeluaran",
  widget_id: "ID Widget",
  property_id: "ID Harta",
  referee: "Ganjaran Yang Dirujuk",
  game_result_free_slots: "Keputusan Permainan (Slot Percuma)",
  crypto_address: "Alamat Kripto",
  crypto_network: "Rangkaian Kripto",
  crypto: "KRIPTO",
  exchange_currency: "Mata Wang Pertukaran",
  base_rate: "Kadar Asas",
  white_label: "White Label",
  aggregator: "Aggregator",
  deposit_rate: "Kadar Deposit",
  withdrawal_rate: "Kadar Pengeluaran",
  pending_bet_list_wbet: "Senarai Pertaruhan Tertunda (WBET)",
  bet_amount: "Jumlah Pertaruhan",
  actual_bet_amount: "Jumlah Pertaruhan Sebenar",
  pending_bet_list_others: "Senarai Pertaruhan Tertunda (Sportsbook Lain)",
  dob: "Tarikh Lahir",
  mail_address: "Alamat Surat",
  crypto_withdrawal: "Pengeluaran Kripto",
  institute_bank_code: "Kod Bank Institusi",
  pending_bet_list_9w: "Senarai Pertaruhan Tertunda (9W)",
  linkage: "Pautan",
  linkage_op: "Operator Pautan",
  member_linkage: "Pautan Ahli",
  risk_weight: "Berat Risiko",
  full_linkage: "Pautan Penuh",
  total_risk_score: "Skor Risiko Keseluruhan",
  linkage_value: "Nilai Pautan",
  source_occurrence_count: "Bilangan Kejadian Sumber",
  source_last_seen_at: "Kali Terakhir Dilihat (Sumber)",
  target_occurrence_count: "Bilangan Kejadian Sasaran",
  target_last_seen_at: "Kali Terakhir Dilihat (Sasaran)",
  member_linkage_detail: "Butiran Pautan Ahli",
  merchant_uid: "ID Pedagang",
  merchant_no: "Nombor Pedagang",
  slot_view: "Paparan Slot",
  settlement_list_affiliate: "Senarai Penyelesaian (Afiliasi)",
  source: "Sumber",
  earning_breakdown: "Pecahan Pendapatan",
  deposit_bonus: "Bonus Deposit",
  winlose_turnover: "WL/TO",
  cost: "Kos",
  promotion_voucher: "Baucar Promosi",
  voucher_id: "ID Voucher",
  voucher_cash: "Kas Voucher",
  ticketvoucher: "Baucar Tiket",
  ticket_voucher_list_member: "Senarai Baucar Tiket (Ahli)",
  ticket_voucher_list: "Senarai Baucar Tiket",
  pending_review_funds_voucher: "Baucar Tiket Tertunda & Dalam Semakan",
  all_pending_ticket_voucher: "Semua Baucar Tiket Tertunda",
  ticket_voucher_detail: "Butiran Baucar Tiket",
  raise_deposit_ticket_voucher: "Cipta Baucar Tiket Deposit",
  raise_deposit_ticket_voucher_gateway: "Cipta Baucar Tiket Deposit Gateway",
  sos: "Topup SOS",
  sos_accumulate_deposit: "Topup SOS (Pengumpulan Deposit)",
  greeting: "Salam",
  message: "Mesej",
  get_voucher: "Dapatkan Baucar",
  get_message: "Dapatkan Mesej",
  voucher: "Baucar",
  code: "Kod",
  redeemed_by: "Ditebus oleh",
  redeemed_by_operator: "Ditebus oleh (Operator)",
  redeemed_at: "Ditebus pada",
  created_at: "Dicipta pada",
  redeemed: "Ditebus",
  member_sos_click_log: "Log Klik SOS Ahli",
  member_wallet_voucher_log: "Log Baucar Dompet Ahli",
  member_voucher_redeemed_log: "Log Penebusan Baucar Ahli",
  action_by_operator: "Tindakan oleh (Operator)",
  redeem_cash: "Tebus Tunai",
  generate_voucher: "Cipta Baucar",
  url_api_freecredit: "URL Callback Kredit Percuma",
  prefix_freecredit: "Awalan Kredit Percuma",
  free_credit_member: "Ahli Kredit Percuma",
  free_credit_provider: "Penyedia Kredit Percuma",
  ticket_detail_fcp: "Butiran Tiket Penyedia Kredit Percuma",
  ticket_list_processed: "Senarai Tiket (Diproses)",
  mission: "Misi",
  non_slot_view: "Paparan Bukan Slot",
  banner: "Banner",
  trigger: "Pencetus",
  event_type: "Jenis Acara",
  action_type: "Jenis Tindakan",
  msg_greeting: "Salam (Mesej)",
  msg_title: "Tajuk (Mesej)",
  msg_body: "Kandungan (Mesej)",
  send_message: "Hantar Mesej",
  promo_type: "Jenis Promosi",
  repeatable: "Berulang",
  rules: "Aturan",
  clear_outstanding_log: "Kosongkan Log Outstanding",
  free_credit_withdrawal_amount: "Jumlah Pengeluaran Kredit Percuma",
  fc_withdrawal_amount: "Jumlah Pengeluaran FC",
  frozen: "Dibekukan",
  transferred: "Dipindahkan",
  voucher_balance: "Baki Baucar",
  adjust_voucher_balance: "Laraskan Baki Baucar",
  free_game_provider: "Penyedia Permainan Percuma",
  check_free_spin: "Semak Free Spin",
  freespin_log: "Log Free Spin",
  current_round: "Pusingan Semasa",
  lines: "Line",
  expiry_interval_days: "Tempoh Tamat Tempoh (Hari)",
  assign: "Tetapkan",
  game_code: "Kod Permainan",
  clear_free_credit: "Kosongkan Kredit Percuma",
  deposit_tier: "Tahap Deposit",
  point: "Mata",
  top: "Atas",
  bottom: "Bawah",
  leaderboard_banner: "Banner Leaderboard",
  referral_banner: "Banner Referral",
  tp_site: "URL Traffic Pool",
  current_icon: "Ikon Semasa",
  new_icon: "Ikon Baharu",
  voucher_redeemed: "Baucar Ditebus",
  on_site: "Di Laman",
  exclude_own: "Kecualikan Sendiri",
  voucher_redeemed_detail: "Butiran Baucar Ditebus",
  gamification: "Gamifikasi",
  reward_rain: "Reward Rain",
  total_claimed_amount: "Jumlah Amaun Dituntut",
  min_amount: "Amaun Minimum",
  max_amount: "Amaun Maksimum",
  reward_rain_session: "Sesi Reward Rain",
  reward_rain_session_claim: "Tuntutan Sesi Reward Rain",
  reward_amount: "Amaun Ganjaran",
  cta: "CTA",
  api_email: "E-mel API",
  api_password: "Kata Laluan API",
  url_callback_voucher: "URL Callback Baucar",
  prefix_voucher: "Awalan Baucar",
  slide_show: "Tayangan Slaid",
  ewallet_withdrawal: "Pengeluaran E-Wallet",
  news: "Berita",
  slug: "Slug",
  preview_body: "Pratonton Kandungan",
  full_body: "Kandungan Penuh",
  normal: "Normal",
  free_balance: "Baki Percuma",
  schema: "Skema",

  tt_pixel_id: "ID Piksel TT",
  tt_token: "Token TT",

  free_spin_bulk_issue : "Free Spin (Pengeluaran Pukal)",
}